<div *ngIf="showMenu">
  <div *ngFor="let item of items; trackBy: getIdentifierForIterableItem">
    <acs-menu-item [item]="item" (menuChanged)="registerToggle($event)"></acs-menu-item>
  </div>
</div>
